import React, { useState, useRef, useEffect } from 'react'; // Import useRef and useEffect
import StickyHeader from "../../../../components/ModuleCommon/StickyHeader/StickyHeader";
import Button from '../../../../components/ACS-Dashboard/ACS-Blocks/Button';
import CreateShipmentTab from '../../Shipment/TabContent/CreateShipmentTab';
import CreatePO from './CreatePO';

const NewOrder = () => {
    const [infoData, setInfoData] = useState({
        "Order date": { type: "date", value: "12/22/2024" },
        "Order number": { type: "text", value: "#004363" },
        "Delivery date request": { type: "date", value: "01/14/2025" },
        "Payment type": { 
            type: "dropdown", 
            value: "",
            options: ["Credit Card", "Bank Transfer", "COD"] 
        }
    });

    const headerRef = useRef(null); // Ref to measure the sticky header height
    const [headerHeight, setHeaderHeight] = useState(64); // Default height

    // Measure the sticky header height on mount and resize
    useEffect(() => {
        if (headerRef.current) {
            const height = headerRef.current.offsetHeight;
            setHeaderHeight(height);
        }

        const handleResize = () => {
            if (headerRef.current) {
                const height = headerRef.current.offsetHeight;
                setHeaderHeight(height);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleInfoChange = (fieldName, newValue) => {
        setInfoData((prevData) => ({
            ...prevData,
            [fieldName]: { ...prevData[fieldName], value: newValue }
        }));
    };

    const templates = ["Template 1", "Template 2", "Template 3"];
    const handleSendPurchaseOrder = () => console.log("Send Purchase Order");
    const handleSaveDraft = () => console.log("Save as Draft");
    const buttons = [
        { label: "Send purchase order", type: "primary", onClick: handleSendPurchaseOrder },
        { label: "Save as draft", type: "secondary", onClick: handleSaveDraft },
    ];
    const [isTemplateSaved, setIsTemplateSaved] = useState(false);

    return (
        <div className="w-full h-full flex flex-col">
            {/* ✅ Sticky Header */}
            <div ref={headerRef} className="sticky mt-1 top-0 z-50 bg-white shadow-md w-full">
                <StickyHeader
                    infoData={infoData}
                    onInfoChange={handleInfoChange}
                    templates={templates}
                    onSelectTemplate={(template) => console.log(`Selected: ${template}`)}
                    buttons={buttons}
                    saveTemplateConfig={{
                        checked: isTemplateSaved,
                        onChange: () => setIsTemplateSaved((prev) => !prev),
                    }}
                />
            </div>

            {/* ✅ Scrollable Form - Full Width */}
            <div 
                className="flex-1 overflow-y-auto bg-gray-50 w-full p-1" 
                style={{ height: `calc(100vh - ${headerHeight}px)` }}
            >
                <CreatePO /> {/* Use the FormMessages component here */}
            </div>
        </div>
    );
    
};

export default NewOrder;